import { AUTH_SUCCESS, LOG_OUT_SUCCESS } from '../actionsTypes/auth';

export default (state = false, {type, payload}) => {
    switch (type) {
        case AUTH_SUCCESS: return true;
        case LOG_OUT_SUCCESS: return false;
        default: return state;
    }
}